var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Sentry from '@sentry/react';
import produce from 'immer';
import React, { createContext, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import uploadFile from './actions/fileUpload';
import cleanMetadata from './actions/metadataClean';
const UploadDocumentContext = createContext({});
const UploadDocumentProvider = (props) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [metadata, setMetadata] = useState([]);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { orgMetadata: anyOrgMetadata } = useSelector((state) => state.orgMetadataState);
    const orgMetadata = anyOrgMetadata;
    const handleFormChange = (name, value) => {
        try {
            setMetadata(produce(metadata, draft => {
                const existingFieldIndex = draft.findIndex(metadataField => metadataField.name === name);
                if (existingFieldIndex !== -1) {
                    draft[existingFieldIndex].value = value;
                }
                else {
                    draft.push({ name, value });
                }
            }));
        }
        catch (err) {
            console.error(err);
            Sentry.captureException(err, { extra: { name, value } });
        }
    };
    const submitFile = () => __awaiter(void 0, void 0, void 0, function* () {
        if (selectedFile === null)
            return;
        setSuccessMessage('');
        setErrorMessage('');
        setUploadInProgress(true);
        try {
            if (!orgMetadata)
                return;
            const cleanedMetadata = cleanMetadata(metadata, orgMetadata);
            const success = yield uploadFile(selectedFile, cleanedMetadata);
            setSuccessMessage(success);
        }
        catch (err) {
            console.error(err);
            Sentry.captureException(err);
            if (err instanceof Error) {
                setErrorMessage(err.message);
            }
        }
        setUploadInProgress(false);
    });
    const resetModel = () => {
        setUploadInProgress(false);
        setSuccessMessage('');
        setErrorMessage('');
        setMetadata([]);
        setSelectedFile(null);
    };
    const value = {
        selectedFile,
        setSelectedFile,
        metadata,
        handleFormChange,
        submitFile,
        uploadInProgress,
        successMessage,
        errorMessage,
        resetModel,
    };
    return React.createElement(UploadDocumentContext.Provider, Object.assign({ value: value }, props));
};
const useUploadDocument = () => {
    const context = useContext(UploadDocumentContext);
    if (!context) {
        throw new Error('UploadDocumentContext must be used inside of a UploadDocumentProvider');
    }
    return context;
};
export { UploadDocumentProvider, useUploadDocument, };
